var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClearCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 34,
    height: 34,
    transform: "translate(550 1030)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_28",
    "data-name": "Mask Group 28",
    transform: "translate(-550 -1030)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_calendar-alt_",
    "data-name": "FontAwsome (calendar-alt)",
    d: "M15.75,3.938V16.313A1.688,1.688,0,0,1,14.063,18H1.688A1.688,1.688,0,0,1,0,16.313V3.938A1.688,1.688,0,0,1,1.688,2.25H3.375V.422A.423.423,0,0,1,3.8,0H5.2a.423.423,0,0,1,.422.422V2.25h4.5V.422A.423.423,0,0,1,10.547,0h1.406a.423.423,0,0,1,.422.422V2.25h1.688A1.688,1.688,0,0,1,15.75,3.938ZM14.063,16.1V5.625H1.688V16.1a.212.212,0,0,0,.211.211H13.852A.212.212,0,0,0,14.063,16.1Z",
    transform: "translate(559.625 1038)",
    fill: "#6e931b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_times_",
    "data-name": "FontAwsome (times)",
    d: "M4.817,83.493,6.8,81.507a.624.624,0,0,0,0-.883l-.441-.441a.624.624,0,0,0-.883,0L3.493,82.169,1.507,80.183a.624.624,0,0,0-.883,0l-.441.441a.624.624,0,0,0,0,.883l1.986,1.986L.183,85.479a.624.624,0,0,0,0,.883l.441.441a.624.624,0,0,0,.883,0l1.986-1.986L5.479,86.8a.624.624,0,0,0,.883,0l.441-.441a.624.624,0,0,0,0-.883Z",
    transform: "translate(564.007 965.507)",
    fill: "#6e931b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearCalendar);
export default __webpack_public_path__ + "static/media/icon_clear_calendar.498c1357cbc365a472680f35c369be3e.svg";
export { ForwardRef as ReactComponent };